import { Select as $ } from './Select.js';
import { SelectOption } from './SelectOption.js';
export * from './Select.js';
export * from './SelectOption.js';

export const Select = Object.assign($, {
  Option: SelectOption,
});
